import React, { ReactElement, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, ButtonType, notification } from 'syngenta-digital-cropwise-react-ui-kit';
import NotificationModel from './NotificatonModel';
import { IConfigNotification } from 'syngenta-digital-cropwise-react-ui-kit/dist/components/notification';

const NotificationProvider = ({
  viewModel,
  children,
}: {
  viewModel: NotificationModel;
  children: React.ReactNode;
}) => {
  useEffect(() => {
    const button_maker = (description: string | ReactElement, button_function: any) => {
      return (
        <div>
          <p>{description}</p>
          <Button
            data-cy="notification_button"
            onClick={button_function}
            type={ButtonType.primary}
            className="float-right"
            size="small"
          >
            Next
          </Button>
        </div>
      );
    };
    const handle_notification = () => {
      let note: any = { ...viewModel.notification };
      const notification_type = viewModel.notification?.type
        ? viewModel.notification.type
        : 'SUCCESS';
      const notification_function =
        notification_type === 'SUCCESS' ? notification.success : notification.error;
      if (viewModel.notification?.button) {
        note.element_description = button_maker(note.description || '', note.button);
      }
      if (note.element_description) {
        note = {
          ...note,
          description: note.element_description,
          onclose: note.button,
        };
      }
      notification_function({
        ...note,
        description: note.element_description ? note.element_description : note.description,
      } as IConfigNotification);
      viewModel.set_notification();
    };
    if (viewModel.notification) {
      handle_notification();
    }
  }, [viewModel, viewModel.notification]);
  return <>{children}</>;
};

export default observer(NotificationProvider);
